module.exports = __webpack_public_path__ + "img/logo-super-air-jet-short.13ba82e8.png";